<template>
  <pdl-form-group
    v-model="paymentMethod"
    name="paymentMethod"
    type="select"
    :multi-items="paymentMethodList"
    :label="$t('text.paymentMethod')"
    required
    :error="fieldError('paymentMethod')"
  />
</template>

<script>
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {mapState, mapMutations} from 'vuex';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';

const paymentMethodConfig = [
  {
    value: 'creditCard',
    label: 'checkout.paymentMethod.creditCard',
  },
];

export default {
  components: {PdlFormGroup},
  mixins: [TrekValidationMixin],
  inject: ['validationErrors'],
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  validations() {
    return {
      paymentMethod: {
        required: this.trekValidators.required('text.bank'),
      },
    };
  },
  computed: {
    ...mapState('checkout', ['paymentData']),
    paymentMethod: {
      get() {
        return this.paymentData.kcpPaymentMethod;
      },
      set(paymentMethod) {
        this.setKcpPaymentMethod(paymentMethod);
      },
    },
    paymentMethodList() {
      return paymentMethodConfig.map((paymentMethod) => ({
        value: paymentMethod.value,
        id: paymentMethod.value,
        displayName: this.$t(paymentMethod.label),
      }));
    },
  },
  mounted() {
    this.setKcpPaymentMethod(paymentMethodConfig[0].value);
  },
  methods: {
    ...mapMutations('checkout', ['setKcpPaymentMethod']),
    fieldError(fieldName) {
      const theError =
        this.validationErrors.find((item) => item.field === fieldName)?.msg ?? this.getErrorMessage(fieldName);

      return theError;
    },
  },
};
</script>
